import { createStorage } from '../cache/index';

const { get, set, remove } = createStorage({
  namespace: 'schedule',
  storage: window.sessionStorage,
});
export function setScheduleToken(value: string) {
  console.log(1111);
  set('schedule-token', value);
}
export function getScheduleToken(): string {
  return get('schedule-token');
}
export function deleteScheduleToken() {
  remove('schedule-token');
}

export function setCurrentTrainInfo(value: any) {
  set('CurrentTrainInfo', value);
}
export function getCurrentTrainInfo(): any {
  return get('CurrentTrainInfo');
}
export function deleteCurrentTrainInfo() {
  remove('CurrentTrainInfo');
}
export function setTrainTypeList(value: any) {
  set('TrainTypeList', value);
}
export function getTrainTypeList(): any {
  return get('TrainTypeList');
}
export function deleteTrainTypeList() {
  remove('TrainTypeList');
}
export function setSelectedMode(value: any) {
  set('SelectedMode', value);
}
export function getSelectedMode(): any {
  return get('SelectedMode');
}
export function deleteSelectedMode() {
  remove('SelectedMode');
}
export function setInitTrainTypeList(value: any) {
  set('InitTrainTypeList', value);
}
export function getInitTrainTypeList(): any {
  return get('InitTrainTypeList');
}
export function deleteInitTrainTypeList() {
  remove('InitTrainTypeList');
}
